<template>
  <div class="swoop-logo-container">
    <img class="swoop-logo" :src="logo" :height="height" :width="width" alt="logo" @click="$emit('click')" @error="$emit('error')" />
  </div>
</template>

<script>
import useWhitelabel from '@/composables/useWhitelabel'

export default {
  props: {
    logoType: {
      type: String,
      default: 'default'
    },
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    }
  },
  setup() {
    const { signupLogoUrl, defaultLogoUrl } = useWhitelabel()
    return { signupLogoUrl, defaultLogoUrl }
  },
  computed: {
    logo() {
      const { logoType, signupLogoUrl, defaultLogoUrl } = this
      return logoType === 'default' ? defaultLogoUrl : signupLogoUrl
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/styles/swoop/variables';

.swoop-logo {
  display: block;
  max-height: 250px;
  max-width: 280px;
  margin-right: auto;
  margin-left: auto;

  @media only screen and (max-width: $breakpoint-sm-max) {
    max-height: 100px;
  }
}
</style>
